import React, {FunctionComponent} from 'react';
import {useDispatch} from 'react-redux';

import {initializeMetadataAndData, resetData} from 'modules/data/data-actions';
import {EEntityType} from 'shared/constants/entities';

import {SimpleActionButton} from '../../components';

interface IButtonRemoveFilterProps {
    actionTitle?: string;
    parentEntityName?: string;
}

export const ButtonRemoveFilter: FunctionComponent<IButtonRemoveFilterProps> = (
    {
        actionTitle = 'Отчистить фильтры',
        parentEntityName,
        ...props
    }: IButtonRemoveFilterProps,
) => {
    const dispatch = useDispatch();
    const handleClick = () => {
        if (parentEntityName) {
            dispatch(resetData({
                entityName: parentEntityName,
                entityType: EEntityType.FILTER,
            }));
            dispatch(initializeMetadataAndData(EEntityType.FILTER)(parentEntityName));
        }
    };

    return (
        <SimpleActionButton
            onClick={handleClick}
            title={actionTitle}
            {...props}
        />
    );
};
